module.exports = __webpack_public_path__ + "static/img/Finish.563304f.png";